import { Fragment } from "react";
import { BRANDS, SPECIALTIES } from "./data";

const Row = ({ items, outline }) => (
  <div className="flex shrink-0 items-center gap-10 pr-10">
    {items.map((t, i) => (
      <Fragment key={t + i}>
        <span className={`font-display font-black uppercase text-5xl md:text-7xl tracking-tight whitespace-nowrap ${outline && i % 2 ? "text-outline" : "text-[#0A0E3F]"}`}>{t}</span>
        <svg viewBox="0 0 24 24" className="w-8 h-8 md:w-10 md:h-10 shrink-0" aria-hidden="true"><circle cx="12" cy="12" r="5" fill="#FF6A13" />{[...Array(8)].map((_, k) => <line key={k} x1="12" y1="1.5" x2="12" y2="4.5" stroke="#FF6A13" strokeWidth="2" strokeLinecap="round" transform={`rotate(${k * 45} 12 12)`} />)}</svg>
      </Fragment>
    ))}
  </div>
);

export const Marquee = () => (
  <section className="relative bg-[#F4EFE6] py-14 md:py-20 overflow-hidden border-y border-[#0A0E3F]/10" data-testid="brands-marquee">
    <div className="flex w-max animate-marquee"><Row items={SPECIALTIES} outline /><Row items={SPECIALTIES} outline /></div>
    <div className="max-w-[1400px] mx-auto px-5 md:px-10 mt-10 flex flex-wrap items-center gap-x-8 gap-y-3">
      <span className="font-mono text-xs uppercase tracking-[0.22em] text-[#0A0E3F]/70">Marcas que trabalhamos</span>
      {BRANDS.map((b) => <span key={b} className="font-display font-bold text-lg text-[#0A0E3F]/80 hover:text-[#FF6A13] transition-colors" data-testid={`brand-${b.toLowerCase()}`}>{b}</span>)}
    </div>
  </section>
);
